(function () {
  'use strict';

  try {
  var context = window.VADE_ANALYTICS_CONTEXT || {};
  var storage = {
    get: function (key) {
      try {
        return window.localStorage.getItem(key);
      } catch (error) {
        return null;
      }
    },
    set: function (key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (error) {
        // Storage can be blocked by privacy settings. Analytics still works without it.
      }
    },
  };
  var sessionStorageSafe = {
    get: function (key) {
      try {
        return window.sessionStorage ? window.sessionStorage.getItem(key) : null;
      } catch (error) {
        return null;
      }
    },
    set: function (key, value) {
      try {
        if (window.sessionStorage) window.sessionStorage.setItem(key, value);
      } catch (error) {
        // Session storage can be blocked. Keep the in-memory value.
      }
    },
  };

  function randomId(prefix) {
    return prefix + '_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
  }

  var visitorId = storage.get('vade_visitor_id');
  if (!visitorId) {
    visitorId = randomId('visitor');
    storage.set('vade_visitor_id', visitorId);
  }

  var sessionId = sessionStorageSafe.get('vade_session_id');
  if (!sessionId) {
    sessionId = randomId('session');
    sessionStorageSafe.set('vade_session_id', sessionId);
  }

  var pageStartedAt = Date.now();
  var scrollDepthsSent = {};
  var engagementMarksSent = {};
  var lastAddToCartKey = null;
  var lastAddToCartAt = 0;
  var eventCount = 0;

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function moneyFromCents(value) {
    if (typeof value !== 'number') return undefined;
    return Math.round(value) / 100;
  }

  function getPageCategory() {
    var path = window.location.pathname;
    if (path === '/' || path === '') return 'home';
    if (path.indexOf('/products/') === 0) return 'product';
    if (path.indexOf('/cart') === 0) return 'cart';
    if (path.indexOf('/collections/') === 0) return 'collection';
    if (path.indexOf('/search') === 0) return 'search';
    if (path.indexOf('/pages/reviews') === 0) return 'reviews';
    if (path.indexOf('/pages/create-your-bundle') === 0) return 'bundle';
    if (path.indexOf('/pages/ugc-athlete-program') === 0) return 'creator_program';
    if (path.indexOf('/pages/') === 0) return 'page';
    return context.template || 'other';
  }

  function basePayload() {
    return {
      event_source: 'vade_theme',
      visitor_id: visitorId,
      session_id: sessionId,
      page_category: getPageCategory(),
      page_path: window.location.pathname,
      page_url: window.location.href,
      page_title: document.title,
      referrer: document.referrer || '',
      currency: context.currency || 'USD',
      template: context.template,
      template_suffix: context.template_suffix,
      customer_logged_in: !!context.customer_logged_in,
      viewport_width: window.innerWidth,
      viewport_height: window.innerHeight,
      seconds_on_page: Math.round((Date.now() - pageStartedAt) / 1000),
    };
  }

  function ecommercePayload(items, value) {
    return {
      currency: context.currency || 'USD',
      value: typeof value === 'number' ? value : undefined,
      items: Array.isArray(items) ? items : [],
    };
  }

  function track(eventName, properties) {
    var payload = Object.assign(basePayload(), properties || {});
    eventCount += 1;
    document.documentElement.setAttribute('data-vade-analytics-last-event', eventName);
    document.documentElement.setAttribute('data-vade-analytics-event-count', String(eventCount));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));

    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', eventName, payload);
      } catch (error) {
        // Keep the site resilient if an analytics vendor is blocked.
      }
    }

    if (typeof window.fbq === 'function') {
      try {
        var fbEvent = {
          add_to_cart: 'AddToCart',
          begin_checkout: 'InitiateCheckout',
          view_item: 'ViewContent',
          search: 'Search',
          generate_lead: 'Lead',
          sign_up: 'Lead',
        }[eventName];

        if (fbEvent) {
          window.fbq('track', fbEvent, {
            content_name: payload.item_name || payload.cta_text || payload.page_title,
            content_ids: payload.variant_id ? [String(payload.variant_id)] : undefined,
            content_type: payload.item_name ? 'product' : undefined,
            value: payload.value,
            currency: payload.currency,
          });
        }
      } catch (error) {
        // Keep the site resilient if Meta is blocked.
      }
    }

    if (window.klaviyo && typeof window.klaviyo.push === 'function') {
      try {
        window.klaviyo.push(['track', 'VADE ' + eventName, payload]);
      } catch (error) {
        // Keep the site resilient if Klaviyo is blocked.
      }
    }

    window.dispatchEvent(new CustomEvent('vade:analytics', { detail: { event: eventName, payload: payload } }));
  }

  function productFromCard(card) {
    if (!card) return {};
    var title = cleanText(card.querySelector('h3, .card__heading, [data-product-title]')?.textContent);
    var selected = card.querySelector('select[name="id"] option:checked');
    var variantId = selected ? selected.value : card.querySelector('[name="id"]')?.value;
    var variant = selected ? cleanText(selected.textContent).replace(/\s-\s\d+\sleft$/i, '') : '';
    var priceText = cleanText(card.querySelector('[data-clearance-sale-price], .price-item--sale, .price-item--regular')?.textContent);
    var price = priceText ? Number(priceText.replace(/[^0-9.]/g, '')) : undefined;
    return {
      item_name: title,
      variant: variant,
      variant_id: variantId,
      price: price,
    };
  }

  function itemFromForm(form) {
    var card = form.closest('.clearance-card, .product, product-info, .quick-add-modal, .create-your-bundle-product-item');
    var item = productFromCard(card);
    var idField = form.querySelector('[name="id"]');
    var quantityField = form.querySelector('[name="quantity"]');
    item.variant_id = item.variant_id || (idField ? idField.value : undefined);
    item.quantity = quantityField ? Number(quantityField.value || 1) : 1;

    if (context.product && !item.item_name) {
      item.item_name = context.product.item_name;
      item.item_id = context.product.item_id;
      item.product_id = context.product.product_id;
      item.variant = context.product.variant;
      item.price = context.product.price;
    }

    return item;
  }

  function trackAddToCart(item, source) {
    if (!item || !item.variant_id) return;
    var key = [item.variant_id, item.quantity || 1, source || 'unknown'].join(':');
    var now = Date.now();
    if (key === lastAddToCartKey && now - lastAddToCartAt < 1000) return;
    lastAddToCartKey = key;
    lastAddToCartAt = now;

    var value = typeof item.price === 'number' ? item.price * (item.quantity || 1) : undefined;
    track('add_to_cart', Object.assign({
      source: source || 'unknown',
      value: value,
      items: [item],
    }, item));
  }

  function getLinkSection(element) {
    var section = element.closest('[id^="shopify-section-"], section, header, footer');
    if (!section) return 'body';
    if (section.id) return section.id.replace(/^shopify-section-/, '');
    return section.tagName.toLowerCase();
  }

  function bindClickTracking() {
    document.addEventListener('click', function (event) {
      var target = event.target.closest('a, button, summary');
      if (!target) return;

      var text = cleanText(target.innerText || target.getAttribute('aria-label') || target.getAttribute('title'));
      var href = target.href || target.getAttribute('formaction') || '';
      var section = getLinkSection(target);

      if (target.closest('.clearance-card__media, .clearance-card h3')) {
        track('select_item', Object.assign({
          source: 'homepage_sale_card',
          list_name: 'Limited stockout sale',
          cta_text: text,
          href: href,
        }, productFromCard(target.closest('.clearance-card'))));
        return;
      }

      if (/checkout|check out/i.test(text) || target.name === 'checkout' || /\/checkout/i.test(href)) {
        track('begin_checkout', Object.assign({
          source: 'cart',
          cta_text: text || 'Checkout',
          value: moneyFromCents(context.cart?.total_price),
          items: context.cart?.items || [],
        }, ecommercePayload(context.cart?.items || [], moneyFromCents(context.cart?.total_price))));
        return;
      }

      if (/apply now|start your application|submit/i.test(text) && window.location.pathname.indexOf('/pages/ugc-athlete-program') === 0) {
        track('generate_lead', {
          source: 'creator_program',
          cta_text: text,
          section: section,
        });
        return;
      }

      if (/shop|bundle|add selected|sale|reviews|creator|learn|see the perks/i.test(text)) {
        track('vade_cta_click', {
          cta_text: text.slice(0, 120),
          href: href,
          section: section,
          source: target.closest('header') ? 'header' : target.closest('footer') ? 'footer' : 'page',
        });
      }
    });
  }

  function bindFormTracking() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') !== -1 || form.querySelector('[name="form_type"][value="product"]')) {
        trackAddToCart(itemFromForm(form), form.closest('.clearance-card') ? 'homepage_sale_card' : 'product_form');
      }

      if (action.indexOf('/search') !== -1 || form.getAttribute('role') === 'search') {
        var query = form.querySelector('[name="q"], input[type="search"]')?.value;
        track('search', {
          search_term: query || '',
          source: 'site_search',
        });
      }

      if (form.querySelector('[name="contact[email]"], input[type="email"]')) {
        track('sign_up', {
          source: 'email_form',
          form_id: form.id || '',
        });
      }
    }, true);

    document.addEventListener('change', function (event) {
      var select = event.target.closest('select');
      if (!select) return;

      if (select.classList.contains('clearance-card__variant-select')) {
        track('vade_variant_select', Object.assign({
          source: 'homepage_sale_card',
          option_label: cleanText(select.options[select.selectedIndex]?.textContent),
        }, productFromCard(select.closest('.clearance-card'))));
        return;
      }

      if (/sort/i.test(select.getAttribute('aria-label') || '') || select.closest('#judgeme_all_reviews_page')) {
        track('vade_review_filter_change', {
          source: 'reviews',
          option_label: cleanText(select.options[select.selectedIndex]?.textContent),
        });
      }
    });
  }

  function bindCartFetchTracking() {
    if (!window.fetch) return;
    var originalFetch = window.fetch;

    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      var init = args[1] || {};
      var body = init.body;
      var cartAction = url.indexOf('/cart/add') !== -1
        ? 'add'
        : url.indexOf('/cart/change') !== -1
          ? 'change'
          : url.indexOf('/cart/update') !== -1
            ? 'update'
            : null;

      return originalFetch.apply(this, args).then(function (response) {
        if (!cartAction) return response;

        response.clone().json().then(function (json) {
          if (json && json.status) {
            track('vade_cart_error', {
              source: 'cart_api',
              cart_action: cartAction,
              message: json.description || json.message || '',
            });
            return;
          }

          if (cartAction === 'add') {
            var item = {};
            if (json && json.variant_id) {
              item = {
                item_id: json.sku || json.variant_id,
                variant_id: json.variant_id,
                product_id: json.product_id,
                item_name: json.product_title || json.title,
                variant: json.variant_title,
                price: moneyFromCents(json.final_price || json.price),
                quantity: json.quantity || 1,
              };
            } else if (body instanceof FormData) {
              item = {
                variant_id: body.get('id'),
                quantity: Number(body.get('quantity') || 1),
              };
            }
            trackAddToCart(item, 'cart_api');
          }

          if (cartAction === 'change' || cartAction === 'update') {
            track('vade_cart_update', {
              source: 'cart_api',
              cart_action: cartAction,
              cart_item_count: json.item_count,
              value: moneyFromCents(json.total_price),
            });
          }
        }).catch(function () {
          // Non-JSON cart responses are ignored.
        });

        return response;
      });
    };
  }

  function bindBundleTracking() {
    document.addEventListener('click', function (event) {
      var bundleItem = event.target.closest('.create-your-bundle-product-item');
      if (!bundleItem) return;

      var button = event.target.closest('button');
      var title = cleanText(bundleItem.querySelector('.create-your-bundle-product-details p')?.textContent);
      var variant = cleanText(bundleItem.querySelector('.create-your-bundle-product-details span')?.textContent);
      var remaining = cleanText(bundleItem.querySelector('.create-your-bundle-product-details small')?.textContent);
      var variantId = button?.getAttribute('variantID');
      var price = Number(cleanText(button?.textContent).replace(/[^0-9.]/g, ''));

      track(button ? 'vade_bundle_item_select' : 'select_item', {
        source: 'bundle_builder',
        item_name: title,
        variant: variant,
        variant_id: variantId,
        price: Number.isFinite(price) ? price : undefined,
        stock_label: remaining,
      });
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.create-your-bundle-form-container button, .create-your-bundle-right button');
      if (!button) return;
      if (!/add selected/i.test(cleanText(button.textContent))) return;

      track('vade_bundle_add_to_cart', {
        source: 'bundle_builder',
        cta_text: cleanText(button.textContent),
      });
    });
  }

  function bindScrollAndEngagement() {
    var thresholds = [25, 50, 75, 90];
    var onScroll = function () {
      var doc = document.documentElement;
      var scrollable = Math.max(doc.scrollHeight - window.innerHeight, 1);
      var depth = Math.round((window.scrollY / scrollable) * 100);
      thresholds.forEach(function (threshold) {
        if (depth >= threshold && !scrollDepthsSent[threshold]) {
          scrollDepthsSent[threshold] = true;
          track('vade_scroll_depth', {
            percent_scrolled: threshold,
          });
        }
      });
    };

    window.addEventListener('scroll', throttle(onScroll, 500), { passive: true });

    [10, 30, 60, 120].forEach(function (seconds) {
      window.setTimeout(function () {
        if (document.hidden || engagementMarksSent[seconds]) return;
        engagementMarksSent[seconds] = true;
        track('vade_engaged_time', {
          engaged_seconds: seconds,
        });
      }, seconds * 1000);
    });
  }

  function throttle(fn, wait) {
    var last = 0;
    var timeout;
    return function () {
      var now = Date.now();
      var remaining = wait - (now - last);
      var args = arguments;
      if (remaining <= 0) {
        window.clearTimeout(timeout);
        timeout = null;
        last = now;
        fn.apply(null, args);
      } else if (!timeout) {
        timeout = window.setTimeout(function () {
          last = Date.now();
          timeout = null;
          fn.apply(null, args);
        }, remaining);
      }
    };
  }

  function initPageEvents() {
    track('vade_page_view', {
      cart_item_count: context.cart?.item_count || 0,
      cart_value: moneyFromCents(context.cart?.total_price),
    });

    if (context.product && getPageCategory() === 'product') {
      track('view_item', Object.assign({
        value: context.product.price,
        items: [context.product],
      }, context.product));
    }

    if (getPageCategory() === 'cart') {
      track('view_cart', ecommercePayload(context.cart?.items || [], moneyFromCents(context.cart?.total_price)));
    }
  }

  window.vadeAnalytics = {
    track: track,
    context: context,
    visitor_id: visitorId,
    session_id: sessionId,
  };
  document.documentElement.setAttribute('data-vade-analytics', 'ready');

  bindClickTracking();
  bindFormTracking();
  bindCartFetchTracking();
  bindBundleTracking();
  bindScrollAndEngagement();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPageEvents, { once: true });
  } else {
    initPageEvents();
  }
  } catch (error) {
    window.vadeAnalyticsBootError = error && (error.stack || error.message || String(error));
    document.documentElement.setAttribute('data-vade-analytics', 'error');
    document.documentElement.setAttribute('data-vade-analytics-last-event', 'vade_analytics_boot_error');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'vade_analytics_boot_error',
      event_source: 'vade_theme',
      message: window.vadeAnalyticsBootError,
      page_path: window.location.pathname,
      page_url: window.location.href,
    });
  }
})();
